import Title_ru_RU from '@/core/misc/decorators/Title_ru_RU';
import TYPES       from '@/core/services/Changelogs/types';

/**
 * Статья бюджета
 * Матвью: oracle.sw_budget_items
 */
class SWBudgetItem {

    /* Идентификатор */
    public id: number;

    /* Код статьи */
    @Title_ru_RU('Код статьи бюджета', TYPES.STRING)
    public code: string;

    /* Наименование статьи */
    @Title_ru_RU('Статья бюджета', TYPES.STRING)
    public name: string;

    static fromServer(data: any, result = new SWBudgetItem()): SWBudgetItem {
        result.id   = data.id;
        result.code = data.code;
        result.name = data.name;
        return result;
    }

    toString() {
        return `${this.code} ${this.name}`;
    }
}

export default SWBudgetItem;
